import { Component, OnDestroy, OnInit } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { AppUser } from '../../../models/user.model';
import { getSelected } from '../../../store/reducers/user';
import { HelperSystem } from '../../helpers/helper.system';


declare var $: any;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit, OnDestroy {

    public menuItems: Array<any> = [];
    public menuItemsAllowed: Array<any> = [];
    user: AppUser = <AppUser>{};
    private subscriber: any;

    constructor(private router: Router,
                private route: ActivatedRoute,
                public translate: TranslateService,
                private store: Store<fromRoot.AppState>) { }

    ngOnInit() {
        $.getScript('./assets/js/app-sidebar.js');
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.subscriber = this.store
          .pipe(select(fromRoot.selectUserState()))
          .subscribe((state: any) => {
              this.user = getSelected(state);
              if (this.user && !this.user.isAdmin) {
                // this.user.permissions_front.filter( (p: any) => p.Path === urlPath)[0];
                this._checkItems(this.user.permissions_front);
              }
              if (this.user && this.user.isAdmin) {
                this.menuItemsAllowed = HelperSystem.deepObjClone(this.menuItems);
              }
        });
    }

    // NGX Wizard - skip url change
    /*ngxWizardFunction(path: string) {
        if (path.indexOf('forms/ngx') !== -1) {
          this.router.navigate(['forms/ngx/wizard'], {skipLocationChange: false});
        }
    }*/
    ngOnDestroy() {
      this.subscriber.unsubscribe();
    }

    private _checkItems(permissions: Array<any> = []) {

      const _prefix = 'manage/';
      const _pathTransform = (path: string, prefix: string = '') => path.substring(prefix.length + 1);

      const _check = (m: any[], parent: any = null): any => {
        m.forEach(_m => {
          if (!_m.path && _m.submenu.length > 0
              && _m.permissionPath && permissions.find((p: any) => p.Path === _pathTransform(_m.permissionPath, _prefix) && p.RA)) {
              parent = HelperSystem.deepObjClone(_m);
              parent.submenu = [];
              this.menuItemsAllowed.push(parent); // make a link
              return _check(_m.submenu, parent);
          }
          if (_m.path && permissions.find((p: any) => p.Path === _pathTransform(_m.path, _prefix) && p.RA)) {
             parent.submenu.push(_m);
          }
        });
      };

      _check(this.menuItems);
    }

}
